// SEO data
export const SEO_DATA = {
  title: "Комбо-уроки по вокалу и фортепиано для взрослых и детей",
  description: "Первый в России уникальный формат, где Вы одновременно учитесь и петь, и играть на фортепиано!",
  keywords: "комбо-уроки, уроки фортепиано, уроки вокала, обучение музыке, преподаватель фортепиано, преподаватель вокала, музыкальная школа, индивидуальные уроки",
  ogImage: "https://voicepiano.ru/assets/background-3.webp",
  ogUrl: "https://voicepiano.ru",
  canonicalUrl: "https://voicepiano.ru"
};

// Brand name
export const BRAND_NAME = 'VoicePiano';

// Navigation menu items
export const MENU_ITEMS = [
  {
    id: 'about-me',
    label: 'Обо мне',
    icon: 'fas fa-user',
    ariaLabel: 'Перейти к разделу Обо мне'
  },
  {
    id: 'benefits',
    label: 'Преимущества',
    icon: 'fa-regular fa-star',
    ariaLabel: 'Перейти к разделу Преимущества'
  },
  {
    id: 'target-audience',
    label: 'Для кого',
    icon: 'fas fa-users',
    ariaLabel: 'Перейти к разделу Для кого'
  },
  {
    id: 'learning-formats',
    label: 'Форматы обучения',
    icon: 'fas fa-graduation-cap',
    ariaLabel: 'Перейти к разделу Форматы обучения'
  },
  {
    id: 'testimonials',
    label: 'Отзывы',
    icon: 'fas fa-comments',
    ariaLabel: 'Перейти к разделу Отзывы'
  },
  {
    id: 'location',
    label: 'Где меня найти?',
    icon: 'fas fa-map-marker-alt',
    ariaLabel: 'Перейти к разделу Где меня найти?'
  },
  {
    id: 'contact',
    label: 'Контакты',
    icon: 'fas fa-envelope',
    ariaLabel: 'Перейти к разделу Контакты',
  }
];

// Hero section
export const HERO_SECTION = {
  title: "Первые в России",
  title_2: "Комбо‑уроки",
  title_3: "Вокал + Фортепиано",
  subtitle: "Уникальный формат, благодаря которому Вы одновременно учитесь и\u00A0петь,\u00A0и\u00A0играть\u00A0на\u00A0фортепиано!",
  primaryButton: "Начать обучение",
  secondaryButton: "Узнать больше"
};

// About me section
export const ABOUT_ME_SECTION = {
  title: "Здравствуйте, мои\u00A0будущие ученики!",
  content: {
    highlight_header: "Музыка — это язык души",
    header: "и уже более 8 лет я помогаю своим ученикам говорить на нем свободно\u00A0и\u00A0уверенно!",
    //greeting: "Здравствуйте, мои будущие ученики!",
    name: "Даниил Жестовский,",
    role: "я профессиональный педагог по вокалу и фортепиано для взрослых и детей!",
    achievement_highlight: "Обучил более 300 человек,",
    achievement: "и каждый из них научился не\u00A0просто\u00A0петь\u00A0и\u00A0играть, а\u00A0выражать\u00A0себя через музыку и творчество.",
    achievement2: "Вместе мы научились быть счастливыми\u00A0и\u00A0свободными!",
    success: ", но\u00A0главное\u00A0—\u00A0обретают уверенность\u00A0и\u00A0радость\u00A0творчества.",
    success_highlight: "Мои ученики выступают на сцене, побеждают в конкурсах",
    highlight2: "У нас всегда много смеха и улыбок на занятиях!"
  }
};

// Achievements section
export const ACHIEVEMENTS_SECTION = {
  title: "Мои достижения",
  items: [
    {
      icon: "fas fa-graduation-cap",
      title: "Образование",
      description: "Окончил лучшие музыкальные учебные заведения страны: Санкт‑Петербургское училище имени Н.А.\u00A0Римского‑Корсакова и Санкт‑Петербургскую консерваторию имени Н.А.\u00A0Римского‑Корсакова"
    },
    {
      icon: "fas fa-trophy",
      title: "Достижения",
      description: "Победитель международного фортепианного конкурса в\u00A0Австрии, Wiener Sterne"
    },
    {
      icon: "fas fa-theater-masks",
      title: "Опыт",
      description: "Выступал на сцене прославленного Мариинского театра"
    }
  ]
};

// Approach section
export const APPROACH_SECTION = {
  title: "Мой подход",
  cards: [
    {
      title: "Бережное раскрытие потенциала",
      highlight: "Не бывает «неталантливых» людей — бывают нереализованные возможности.",
      description: "Я помогу открыть для Вас природное богатство Вашего голоса и индивидуальную манеру игры на фортепиано — бережно и с любовью к Вашей уникальности."
    },
    {
      title: "Психологический комфорт",
      highlight: "Мои программы — это не только про навыки, но и про психологический комфорт.",
      description: "Пение и игра должны приносить радость, снимать напряжение, дарить ощущение свободы.",
      description_2: "Под Ваши цели и особенности я подберу максимально комфортный и приятный путь\u00A0развития."
    },
    {
      title: "Академический подход",
      highlight: "Опираясь на академическое музыкальное образование и европейский исполнительский опыт",
      description: "Я разработал систему, где классические знания подаются через призму современной европейской педагогики. Никакой избыточной теории — только проверенные на практике инструменты для быстрого прогресса."
    }
  ]
};

// Benefits section
export const BENEFITS_SECTION = {
  title: "Почему Комбо‑уроки Ваш идеальный выбор?",
  items: [
    {
      icon: "fa-regular fa-star",
      title: "Раскрытие потенциала",
      description: "Максимальная реализация Ваших творческий возможностей"
    },
    {
      icon: "fa-regular fa-thumbs-up",
      title: "Качественный результат",
      description: "Несколько занятий достаточно, чтобы Вы сыграли и спели свое первое произведение"
    },
    {
      icon: "fa-regular fa-heart",
      title: "Снятие стресса",
      description: "Уроки, которые помогают бороться с высоким уровнем напряжения, возвращая душевное равновесие"
    }
  ]
};

// Target audience section
export const TARGET_AUDIENCE_SECTION = {
  title: "Для кого подходят уроки",
  cards: [
    {
      title: "Начинающие",
      description: "Если Вы задумываетесь начать заниматься, то Комбо‑уроки — это отличный способ сразу погрузиться в мир музыки с двух сторон.",
      details: [
        "Вы научитесь не только красиво петь, но и играть любимые произведения, а также аккомпанировать себе во время исполнения песен, что даст Вам более глубокое понимание музыки.",
        "Это возможность раскрыть свои таланты и найти новые источники вдохновения."
      ],
      features: [
        "Научитесь петь и аккомпанировать себе",
        "Глубокое понимание музыки",
        "Раскрытие талантов"
      ]
    },
    {
      title: "Родители",
      description: "Комбо‑уроки это идеальное решение, если Вы хотите, чтобы Ваш ребенок вырос многогранной, уверенной и\u00A0креативной\u00A0личностью.",
      details: [
        "Это не просто занятия, а\u00A0полноценное\u00A0развитие: творческое, интеллектуальное и эмоциональное.",
        "Ваш ребенок научится не только петь и играть, но и выражать себя через творчество, уверенно выступать перед публикой.",
        "Это инвестиция в его будущее, которая подарит ему уверенность, дисциплину и радость от достижений."
      ],
      features: [
        "Творческое развитие",
        "Уверенность в себе",
        "Дисциплина и достижения"
      ]
    },
    {
      title: "Люди, которые ценят свое время",
      description: "Обучение двум направлениям одновременно ускоряет прогресс и делает занятия более эффективными.",
      details: [
        "Вместо того чтобы посещать два отдельных курса, Вы получаете комплексное обучение, которое ускоряет ваш прогресс.",
        "Это особенно удобно для тех, у кого плотный график, но есть большое желание развиваться в творческой сфере."
      ],
      features: [
        "Эффективное использование времени",
        "Комплексное обучение",
        "Быстрый прогресс"
      ]
    },
    {
      title: "Профессионалы",
      description: "Если Вы уже занимаетесь вокалом или игрой на фортепиано, Комбо‑уроки помогут Вам выйти на новый уровень.",
      details: [
        "Например, вокалисты смогут научиться аккомпанировать себе, а пианисты — развить свой голос и научиться петь.",
        "Это расширит Ваши возможности как музыканта и сделает Вас более универсальным артистом."
      ],
      features: [
        "Расширение навыков",
        "Универсальность",
        "Новые возможности"
      ]
    },
    {
      title: "Творческие личности",
      description: "Для тех, кто любит экспериментировать и ищет нестандартные подходы к обучению.",
      details: [
        "Комбо‑уроки представляют уникальную возможность для творческого самовыражения и экспериментов с музыкой.",
        "Здесь Вы научитесь не просто играть, но и сочинять, превращая свои мысли и идеи в яркие мелодии.",
        "Наши уроки-это время, когда рождается Ваш собственный звук, отражающий душу и характер."
      ],
      features: [
        "Экспериментальный подход",
        "Творческое развитие",
        "Самовыражение"
      ]
    }
  ]
};

// Overcoming fears section
export const OVERCOMING_FEARS_SECTION = {
  title: "Если Вы давно хотели",
  items: [
    {
      icon: "fas fa-microphone",
      title: "Начать петь с нуля",
      description: "Преодолеть страх перед пением и раскрыть свой голос"
    },
    {
      icon: "fas fa-music",
      title: "Играть любимую музыку",
      description: "Исполнить мечту и научиться играть на фортепиано"
    },
    {
      icon: "fas fa-guitar",
      title: "Создавать музыку",
      description: "Начать сочинять собственные композиции"
    },
    {
      icon: "fas fa-child",
      title: "Развить таланты ребенка",
      description: "Дать своему ребенку возможность творчески самовыражаться"
    },
    {
      icon: "fas fa-theater-masks",
      title: "Побороть страх выступлений",
      description: "Преодолеть волнение и уверенно выступать перед публикой"
    },
    {
      icon: "fas fa-user-shield",
      title: "Стать увереннее в себе",
      description: "Развить уверенность через творческое самовыражение"
    },
    {
      icon: "fas fa-heart",
      title: "Найти внутреннюю гармонию",
      description: "Проработать негативные эмоции и прийти к внутренней гармонии"
    }
  ],
  cta: {
    text: "Тогда Комбо‑уроки для Вас и для Ваших детей, потому что это не только увлекательное хобби, но и важный компонент личностного развития и гармонии в жизни",
    button: "Начать свой путь в музыке"
  }
};

// Learning formats section
export const LEARNING_FORMATS_SECTION = {
  title: "Форматы обучения",
  formats: [
    {
      icon: "fas fa-users",
      title: "Групповые занятия",
      description: "Занятия в мини-группах для совместного творчества.",
      price_title: "Первое занятие",
      price: "от 2500 руб.",
      forWhom: {
        title: "Для кого:",
        items: [
          "Те, кто любит учиться в компании",
          "Ученики, желающие сэкономить",
          "Те, кто хочет делиться опытом"
        ]
      },
      features: {
        title: "Особенности:",
        items: [
          "Взаимодействие с другими",
          "Совместное творчество",
          "Мотивация от группы",
          "Доступная цена"
        ]
      }
    },
    {
      icon: "fas fa-user",
      title: "Индивидуальные занятия",
      description: "Для тех, кто хочет максимально персонализированного подхода.",
      featured: true,
      price_title: "Первое занятие",
      price: "от 2500 руб.",
      forWhom: {
        title: "Для кого:",
        items: [
          "Ученики, которые ценят внимание преподавателя",
          "Те, кто стесняется заниматься в группе",
          "Предпочитающие учиться в своем темпе"
        ]
      },
      features: {
        title: "Особенности:",
        items: [
          "Персональный подход",
          "Гибкий график",
          "Максимум внимания",
          "Быстрый прогресс"
        ]
      }
    },
    {
      icon: "fas fa-laptop",
      title: "Онлайн занятия",
      description: "Удобный формат для занятий из любой точки мира.",
      price_title: "Первое занятие",
      price: "от 2500 руб.",
      forWhom: {
        title: "Для кого:",
        items: [
          "Живущие в других городах или странах",
          "Ученики с плотным графиком",
          "Предпочитающие домашнюю обстановку"
        ]
      },
      features: {
        title: "Особенности:",
        items: [
          "Удобство из любой точки мира",
          "Экономия времени",
          "Гибкий график",
          "Доступные цены"
        ]
      }
    },
    {
      icon: "fas fa-home",
      title: "Семейные занятия",
      description: "Совместное творчество для всей семьи.",
      price_title: "Первое занятие",
      price: "от 2500 руб.",
      forWhom: {
        title: "Для кого:",
        items: [
          "Родители, желающие учиться вместе с детьми",
          "Пары, ищущие совместное хобби",
          "Те, кто хочет укрепить семейные узы"
        ]
      },
      features: {
        title: "Особенности:",
        items: [
          "Занятия в формате \"родитель + ребенок\"",
          "Программа для всех возрастов",
          "Укрепление семейных отношений",
          "Совместные музыкальные проекты"
        ]
      }
    },
    {
      icon: "fas fa-building",
      title: "Корпоративные занятия",
      description: "Творческий тимбилдинг для компаний.",
      price_title: "Первое занятие",
      price: "По запросу",
      forWhom: {
        title: "Для кого:",
        items: [
          "Компании, организующие тимбилдинг",
          "Коллективы, ищущие необычный формат",
          "Фирмы, заботящиеся о ментальном здоровье своих сотрудников"
        ]
      },
      features: {
        title: "Особенности:",
        items: [
          "Групповые или индивидуальные занятия",
          "Сплочение коллектива",
          "Корпоративные концерты",
          "Снижение уровня стресса"
        ]
      }
    }
  ]
};

// Contact section
export const CONTACT_SECTION = {
  title: "Начните обучение сегодня",
  description: "Если Вы давно хотели начать петь с нуля, играть любимую музыку или дать своему ребенку возможность творчески самовыражаться, то Комбо‑уроки\u00A0для\u00A0Вас!",
  button: "Связаться со мной"
};

// Footer
export const FOOTER = {
  copyright: "© 2025 VoicePiano. Все права защищены."
};

// Testimonials
export const AVITO_LINK = "https://www.avito.ru/sankt-peterburg/predlozheniya_uslug/repetitor_po_vokalu_i_fortepiano_dlya_detey_4347178153#open-reviews-list";
export const PROFI_LINK = "https://profi.ru/profile/ZhestovskiiDA";
export const YANDEX_LINK = "https://uslugi.yandex.ru/profile/DaniilZhestovskij-854589";
export const TESTIMONIALS = [
  {
    id: 1,
    text: "Даниил очень талантливый преподаватель с уникальной методикой обучения. Удобно, что можно одновременно учиться игре на фортепиано и вокалу.",
    name: "Алена",
    role: "30 марта 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=А",
    link: AVITO_LINK
  },
  {
    id: 2,
    text: "Безумно благодарна Даниилу! Настоящий профессионал своего дела. И вокал, и фортепиано одновременно. Это то, что я давно хотела) Занятия проходят безумно весело, и при это продуктивность 100%!",
    name: "Наталья",
    role: "17 марта 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=A",
    link: PROFI_LINK
  },
  {
    id: 3,
    text: "Даниил создал потрясающий формат занятий, который идеально сбалансирован между обучением игре на фортепиано и вокалом!",
    name: "Сергей",
    role: "22 апреля 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=Ю",
    link: YANDEX_LINK
  },
  {
    id: 4,
    text: "Рекомендую каждому, кто ищет для себя не просто репетитора, а именно учителя, который делится знаниями, опытом, подает материал в простой форме, и обладает отменным чувством юмора",
    name: "Алина",
    role: "27 августа 2024",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=Е",
    link: PROFI_LINK
  },
  {
    id: 5,
    text: "Даниил - харизматичный преподаватель. Прогресс после занятий стал заметен. Все объясняет доходчиво.",
    name: "Карина",
    role: "22 февраля 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=К",
    link: AVITO_LINK
  },
  {
    id: 6,
    text: "Очень нравится индивидуальный подход. Легкая атмосфера, подкрепленная классными шутками.",
    name: "Ольга",
    role: "8 февраля 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=О",
    link: AVITO_LINK
  },
  {
    id: 7,
    text: "Мне говорили, что слуха нет, но тут открывают скрытые способности. Спасибо за комфортную атмосферу!",
    name: "Валерия",
    role: "5 февраля 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=В",
    link: AVITO_LINK
  },
  {
    id: 8,
    text: "Ни у кого еще не видел, что можно заниматься и вокалом, и фортепиано одновременно Мне очень нравится заниматься у Даниила Все очень просто и понятно объясняет и показывает",
    name: "Роберт Гараев",
    role: "19 апреля 2024",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=А",
    link: YANDEX_LINK
  },
  {
    id: 9,
    text: "Занимаюсь у Даниила вокалом и фортепиано. Он настоящий мастер своего дела, так понятно и просто все объясняет! Безумно доволен нашими уроками!",
    name: "Виктор",
    role: "31 августа 2024",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=А",
    link: PROFI_LINK
  },
  {
    id: 10,
    text: "Я давно мечтал научиться играть на фортепиано. Спасибо Даниилу, который развеял мои страхи и сделал процесс обучения увлекательным!",
    name: "Юрий",
    role: "12 марта 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=Ю",
    link: AVITO_LINK
  },
  {
    id: 11,
    text: "Если ребенок с радостью бежит на занятия — это говорит о таланте преподавателя. Видим четкий прогресс.",
    name: "Наталья",
    role: "8 ноября 2024",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=Н",
    link: AVITO_LINK
  },
  {
    id: 12,
    text: "Спасибо большое Даниилу! Занятия проходят с легкостью Все понятно, а главное, я сразу вижу результат",
    name: "Анастасия",
    role: "29 марта 2025",
    avatar: "https://placehold.co/100x100/2b1307/ffffff?text=А",
    link: YANDEX_LINK
  }
];
